import initI18n from '@quicktools/shared-components/services/i18n';
import React, { useEffect } from 'react';
import { AnalyticsScript, SingleToolsBootstrap } from '@quicktools/shared-components';
import Script from 'next/script';

import translations from '../services/i18n/translation.json';
import { RECAPTCHA_SITE_KEY } from '../configs';
import analytics from '../services/analytics';

import type { AppProps } from 'next/app';

initI18n(translations);

function MyApp({ Component, pageProps }: AppProps) {
  useEffect(() => {
    analytics.pageOpen();
  }, []);

  return (
    <>
      <Script
        async
        strategy="afterInteractive"
        src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"
      />

      <AnalyticsScript recaptchaSiteKey={RECAPTCHA_SITE_KEY} />

      <SingleToolsBootstrap>
        <Component {...pageProps} />
      </SingleToolsBootstrap>
    </>
  );
}

export default MyApp;
